/* Split from ruckstuhl-fixes.js; function-scoped loading for performance. */
/* Ruckstuhl V8 RC21 – technische Bahnenware-Skizze
   - Teppich bleibt unabhängig von der Laufrichtung im eingegebenen Mass ausgerichtet
   - Seitenverhältnis entspricht immer Breite × Länge des Fertigmasses
   - nur Bahnen, Schweissnähte und Restmaterial drehen sich mit der Laufrichtung
   - Schweissnähte immer gleichmässig im Fertigmass
   - ohne Naht ein grosses Reststück; mit Naht symmetrisch auf beiden Materialseiten
   - kein Laufrichtungspfeil
   - runde Teppiche werden rund dargestellt
*/
(function(){
  'use strict';

  function number(value){
    var parsed=parseFloat(String(value==null?'':value).replace(',','.'));
    return isFinite(parsed)?parsed:0;
  }
  function formatMetres(value){
    try{
      return new Intl.NumberFormat(document.documentElement.lang||'de-CH',{
        minimumFractionDigits:2,
        maximumFractionDigits:2
      }).format(value)+' m';
    }catch(error){
      return value.toFixed(2)+' m';
    }
  }
  function escapeHtml(value){
    return String(value==null?'':value).replace(/[&<>"']/g,function(character){
      return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[character];
    });
  }
  function translate(key,fallback,variables){
    return window.RKV8T?window.RKV8T(key,fallback,variables):fallback;
  }
  function modalFrom(node){
    return node&&node.closest?node.closest('.rk-at-modal--bahnenware,[data-rk-at-modal][data-rk-bahnenware-version]'):null;
  }
  function parseData(modal){
    var element=modal&&modal.querySelector('[id$="-data"]');
    if(!element)return {};
    try{return JSON.parse(element.textContent||'{}');}catch(error){return {};}
  }
  function inputValue(modal,suffix){
    var element=modal.querySelector('[id$="-'+suffix+'"]');
    return number(element&&element.value);
  }
  function mode(modal){
    var element=modal.querySelector('.tk-config-mode:checked');
    return element?String(element.value||''):'';
  }
  function shape(modal){
    var element=modal.querySelector('[id$="-shape"]');
    return String(element&&element.value||'').toLowerCase();
  }
  function direction(modal){
    return modal.dataset.rkAtMaterialDirection==='quer'?'quer':'laengs';
  }
  function dimensions(modal){
    var width=inputValue(modal,'width');
    var length=inputValue(modal,'length');
    var diameter=inputValue(modal,'diameter');
    var currentShape=shape(modal);
    if(currentShape==='rund'){
      return {width:diameter,length:diameter,diameter:diameter,round:true,oval:false};
    }
    if(currentShape==='oval'){
      return {width:width,length:length,diameter:0,round:false,oval:true};
    }
    return {width:width,length:length,diameter:0,round:false,oval:false};
  }
  function visualDimensions(modal){
    /*
      Das Fertigmass bleibt in der Skizze immer gleich ausgerichtet:
      Breite horizontal, Länge vertikal. Die Laufrichtung verändert nur
      die Ausrichtung der Produktionsbahnen, Nähte und Restflächen.
    */
    return dimensions(modal);
  }

  function buildSketch(modal){
    if(!modal||mode(modal)==='m2')return '';

    var dims=dimensions(modal);
    var visual=visualDimensions(modal);
    if(!dims.width||!dims.length)return '';

    var data=parseData(modal);
    var rollWidth=number(data.product&&data.product.roll_width_m);
    var dir=direction(modal);
    var isCross=dir==='quer';

    /*
      Produktionslogik:
      - Längs: Rollenbreite liegt über der Teppichbreite; Nähte verlaufen vertikal.
      - Quer: Rollenbreite liegt über der Teppichlänge; Nähte verlaufen horizontal.
      Das sichtbare Fertigmass selbst wird dabei nie gedreht.
    */
    var productionAcross=dims.round?dims.diameter:(isCross?dims.length:dims.width);
    var productionAlong=dims.round?dims.diameter:(isCross?dims.width:dims.length);
    var laneCount=rollWidth>0?Math.max(1,Math.ceil(productionAcross/rollWidth)):1;
    var weldCount=Math.max(0,laneCount-1);
    var usedAcross=rollWidth>0?laneCount*rollWidth:productionAcross;
    var totalRest=Math.max(0,usedAcross-productionAcross);

    /*
      Ohne Schweissnaht wird das Fertigmass an eine Materialkante gelegt,
      damit ein möglichst grosses zusammenhängendes Reststück entsteht.
      Ab einer Schweissnaht wird das Restmaterial symmetrisch verteilt.
    */
    var leadingRest=weldCount>0?totalRest/2:0;
    var trailingRest=Math.max(0,totalRest-leadingRest);

    var materialRealWidth=isCross?productionAlong:usedAcross;
    var materialRealHeight=isCross?usedAcross:productionAlong;
    var carpetRealWidth=dims.width;
    var carpetRealHeight=dims.length;

    var canvasWidth=760;
    var canvasHeight=390;
    var paddingX=74;
    var paddingTop=60;
    var paddingBottom=62;
    var availableWidth=canvasWidth-paddingX*2;
    var availableHeight=canvasHeight-paddingTop-paddingBottom;
    var scale=Math.min(
      availableWidth/Math.max(materialRealWidth,.1),
      availableHeight/Math.max(materialRealHeight,.1)
    );

    var materialWidth=materialRealWidth*scale;
    var materialHeight=materialRealHeight*scale;
    var materialX=(canvasWidth-materialWidth)/2;
    var materialY=paddingTop+(availableHeight-materialHeight)/2;

    var carpetWidth=carpetRealWidth*scale;
    var carpetHeight=carpetRealHeight*scale;
    var carpetX=isCross?materialX:(materialX+leadingRest*scale);
    var carpetY=isCross?(materialY+leadingRest*scale):materialY;
    var clipId='rkShapeClip'+String(Date.now())+String(Math.random()).slice(2,7);

    var source='';
    if(totalRest>0.0001){
      source+='<rect class="rk-material" x="'+materialX+'" y="'+materialY+'" width="'+materialWidth+'" height="'+materialHeight+'"/>';
      if(!isCross){
        if(leadingRest>0.0001){
          source+='<rect class="rk-rest" x="'+materialX+'" y="'+materialY+'" width="'+(leadingRest*scale)+'" height="'+materialHeight+'"/>';
        }
        if(trailingRest>0.0001){
          source+='<rect class="rk-rest" x="'+(carpetX+carpetWidth)+'" y="'+materialY+'" width="'+(trailingRest*scale)+'" height="'+materialHeight+'"/>';
        }
      }else{
        if(leadingRest>0.0001){
          source+='<rect class="rk-rest" x="'+materialX+'" y="'+materialY+'" width="'+materialWidth+'" height="'+(leadingRest*scale)+'"/>';
        }
        if(trailingRest>0.0001){
          source+='<rect class="rk-rest" x="'+materialX+'" y="'+(carpetY+carpetHeight)+'" width="'+materialWidth+'" height="'+(trailingRest*scale)+'"/>';
        }
      }
    }

    var carpet='';
    var seams='';
    if(dims.round){
      var radius=Math.min(carpetWidth,carpetHeight)/2;
      var centreX=carpetX+carpetWidth/2;
      var centreY=carpetY+carpetHeight/2;
      carpet='<defs><clipPath id="'+clipId+'"><circle cx="'+centreX+'" cy="'+centreY+'" r="'+radius+'"/></clipPath></defs>'+ 
        '<circle class="rk-rug" cx="'+centreX+'" cy="'+centreY+'" r="'+radius+'"/>';
      if(laneCount>1){
        for(var roundIndex=1;roundIndex<laneCount;roundIndex+=1){
          if(isCross){
            var roundY=carpetY+(carpetHeight*roundIndex/laneCount);
            seams+='<line class="rk-seam" clip-path="url(#'+clipId+')" x1="'+carpetX+'" y1="'+roundY+'" x2="'+(carpetX+carpetWidth)+'" y2="'+roundY+'"/>';
          }else{
            var roundX=carpetX+(carpetWidth*roundIndex/laneCount);
            seams+='<line class="rk-seam" clip-path="url(#'+clipId+')" x1="'+roundX+'" y1="'+carpetY+'" x2="'+roundX+'" y2="'+(carpetY+carpetHeight)+'"/>';
          }
        }
      }
    }else if(dims.oval){
      var ovalCentreX=carpetX+carpetWidth/2;
      var ovalCentreY=carpetY+carpetHeight/2;
      var ovalRx=carpetWidth/2;
      var ovalRy=carpetHeight/2;
      carpet='<defs><clipPath id="'+clipId+'"><ellipse cx="'+ovalCentreX+'" cy="'+ovalCentreY+'" rx="'+ovalRx+'" ry="'+ovalRy+'"/></clipPath></defs>'+ 
        '<ellipse class="rk-rug" cx="'+ovalCentreX+'" cy="'+ovalCentreY+'" rx="'+ovalRx+'" ry="'+ovalRy+'"/>';
      if(laneCount>1){
        for(var ovalIndex=1;ovalIndex<laneCount;ovalIndex+=1){
          if(isCross){
            var ovalY=carpetY+(carpetHeight*ovalIndex/laneCount);
            seams+='<line class="rk-seam" clip-path="url(#'+clipId+')" x1="'+carpetX+'" y1="'+ovalY+'" x2="'+(carpetX+carpetWidth)+'" y2="'+ovalY+'"/>';
          }else{
            var ovalX=carpetX+(carpetWidth*ovalIndex/laneCount);
            seams+='<line class="rk-seam" clip-path="url(#'+clipId+')" x1="'+ovalX+'" y1="'+carpetY+'" x2="'+ovalX+'" y2="'+(carpetY+carpetHeight)+'"/>';
          }
        }
      }
    }else{
      carpet='<rect class="rk-rug" x="'+carpetX+'" y="'+carpetY+'" width="'+carpetWidth+'" height="'+carpetHeight+'"/>';
      if(laneCount>1){
        for(var index=1;index<laneCount;index+=1){
          if(isCross){
            var seamY=carpetY+(carpetHeight*index/laneCount);
            seams+='<line class="rk-seam" x1="'+carpetX+'" y1="'+seamY+'" x2="'+(carpetX+carpetWidth)+'" y2="'+seamY+'"/>';
          }else{
            var seamX=carpetX+(carpetWidth*index/laneCount);
            seams+='<line class="rk-seam" x1="'+seamX+'" y1="'+carpetY+'" x2="'+seamX+'" y2="'+(carpetY+carpetHeight)+'"/>';
          }
        }
      }
    }

    var labels='';
    if(dims.round){
      labels+='<text x="'+(carpetX+carpetWidth/2)+'" y="'+(materialY-19)+'" text-anchor="middle">'+escapeHtml(translate('diameter','Durchmesser'))+' '+escapeHtml(formatMetres(visual.diameter))+'</text>';
    }else{
      var horizontalLabel=isCross?translate('length','Länge'):translate('width','Breite');
      var verticalLabel=isCross?translate('width','Breite'):translate('length','Länge');
      labels+='<text x="'+(carpetX+carpetWidth/2)+'" y="'+(materialY-19)+'" text-anchor="middle">'+escapeHtml(horizontalLabel)+' '+escapeHtml(formatMetres(visual.width))+'</text>';
      labels+='<text x="'+(materialX-22)+'" y="'+(carpetY+carpetHeight/2)+'" text-anchor="middle" transform="rotate(-90 '+(materialX-22)+' '+(carpetY+carpetHeight/2)+')">'+escapeHtml(verticalLabel)+' '+escapeHtml(formatMetres(visual.length))+'</text>';
    }
    if(totalRest>0.0001){
      var restLabel=weldCount>0
        ? escapeHtml(translate('remaining_material','Restmaterial'))+' '+escapeHtml(formatMetres(totalRest/2))+' '+escapeHtml(translate('per_side','je Seite'))
        : escapeHtml(translate('remaining_material','Restmaterial'))+' '+escapeHtml(formatMetres(totalRest));
      labels+='<text x="'+(canvasWidth/2)+'" y="'+(materialY+materialHeight+31)+'" text-anchor="middle">'+restLabel+'</text>';
    }

    return '<svg viewBox="0 0 '+canvasWidth+' '+canvasHeight+'" role="img" aria-label="'+escapeHtml(translate('technical_sketch','Technische Skizze'))+'">'+source+carpet+seams+labels+'</svg>';
  }

  function svgData(svg){
    return svg?'data:image/svg+xml;charset=utf-8,'+encodeURIComponent(svg):'';
  }

  function update(modal){
    if(!modal)return;
    var material=modal.querySelector('[data-rk-at-slot="material"]');
    if(!material)return;

    var boxes=material.querySelectorAll('[data-rk-v8-material-sketch]');
    var box=boxes[0];
    for(var duplicateIndex=1;duplicateIndex<boxes.length;duplicateIndex+=1){
      boxes[duplicateIndex].remove();
    }
    if(!box){
      box=document.createElement('div');
      box.className='rk-v8-material-sketch';
      box.setAttribute('data-rk-v8-material-sketch','');
      material.insertBefore(box,material.firstChild);
    }

    var svg=buildSketch(modal);
    if(!svg){
      box.hidden=true;
      box.innerHTML='';
      modal.dataset.rkV8Sketch='';
      return;
    }
    box.hidden=false;
    box.innerHTML='<p class="rk-v8-material-sketch__title">'+escapeHtml(translate('technical_sketch','Technische Skizze'))+'</p>'+svg+
      '<div class="rk-v8-material-sketch__meta"><span>'+escapeHtml(translate('direction','Laufrichtung'))+': '+escapeHtml(direction(modal)==='quer'?translate('direction_cross','Quer'):translate('direction_long','Längs'))+'</span></div>';
    modal.dataset.rkV8Sketch=svgData(svg);
  }

  function enhance(detail){
    if(!detail||String(detail.configuratorType||detail.configurator_type||'').toLowerCase()!=='bahnenware')return detail;
    var modal=document.querySelector('.rk-at-modal--bahnenware.is-open,.rk-at-modal--bahnenware');
    if(!modal)return detail;
    update(modal);
    var image=modal.dataset.rkV8Sketch;
    if(image){
      var images=Array.isArray(detail.preview_images)?detail.preview_images.slice():[];
      [detail.preview_image,detail.edging_image,image].filter(Boolean).forEach(function(source){
        if(images.indexOf(source)<0)images.push(source);
      });
      detail.preview_images=images;
      detail.sketch_image=image;
    }

    var dims=dimensions(modal);
    var data=parseData(modal);
    var rollWidth=number(data.product&&data.product.roll_width_m);
    var across=dims.round?dims.diameter:(direction(modal)==='quer'?dims.length:dims.width);
    var along=dims.round?dims.diameter:(direction(modal)==='quer'?dims.width:dims.length);
    var weldCount=rollWidth>0?Math.max(0,Math.ceil(across/rollWidth)-1):0;
    if(weldCount>0){
      var rows=Array.isArray(detail.details)?detail.details:[];
      var key=weldCount===1?'weld_singular':'weld_plural';
      var label=translate(key,weldCount===1?'Schweissnaht':'Schweissnähte');
      var value=weldCount+' × '+formatMetres(along);
      if(!rows.some(function(row){
        var rowLabel=String(row&&row.label||'').toLowerCase();
        return rowLabel.indexOf('schweiss')>=0||rowLabel.indexOf('weld')>=0;
      }))rows.push({label:label,value:value});
      detail.details=rows;
    }
    return detail;
  }

  function wrapCore(){
    if(!window.RKConfiguration||window.RKConfiguration.__rk17)return false;
    ['open','pdf'].forEach(function(method){
      var original=window.RKConfiguration[method];
      if(typeof original!=='function')return;
      window.RKConfiguration[method]=function(detail){
        arguments[0]=enhance(detail||{});
        return original.apply(this,arguments);
      };
    });
    window.RKConfiguration.__rk17=true;
    return true;
  }

  function scheduleUpdate(modal){
    window.clearTimeout(modal.__rkSketchTimer);
    modal.__rkSketchTimer=window.setTimeout(function(){update(modal);},40);
  }

  function init(){
    document.querySelectorAll('.rk-at-modal--bahnenware').forEach(update);
    document.addEventListener('input',function(event){
      var modal=modalFrom(event.target);
      if(!modal || mode(modal)==='m2') return;
      if(event.target && event.target.matches && event.target.matches('[id$="-width"],[id$="-length"],[id$="-diameter"]')) scheduleUpdate(modal);
    },true);
    document.addEventListener('change',function(event){
      var modal=modalFrom(event.target);
      if(!modal || mode(modal)==='m2') return;
      if(event.target && event.target.matches && event.target.matches('[id$="-width"],[id$="-length"],[id$="-diameter"],[id$="-shape"],.tk-config-mode')) scheduleUpdate(modal);
    },true);
    window.addEventListener('tk:direction:update',function(){
      document.querySelectorAll('.rk-at-modal--bahnenware').forEach(scheduleUpdate);
    });
    var attempts=0;
    var timer=window.setInterval(function(){
      if(wrapCore()||++attempts>80)window.clearInterval(timer);
    },100);
  }

  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);
  else init();
})()
